import script from "./FormCheckBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormCheckBox.vue?vue&type=script&lang=ts&setup=true"

import "./FormCheckBox.vue?vue&type=style&index=0&id=0ad63eaa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad63eaa"]])

export default __exports__